import React, { createContext, useContext, useEffect, useState } from "react";
import { apiRequest } from "../utils/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);      // ユーザー情報
  const [loading, setLoading] = useState(true); // ローディング状態

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await apiRequest("accounts/me/");
        setUser(res);
      } catch (err) {
        console.log("Auth error:", err);

        if (err?.status === 401) {
          localStorage.removeItem("access");
          localStorage.removeItem("refresh");
        }

        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => useContext(AuthContext);
